import type { PropsWithChildren } from "react";
import {
	FormControl,
	FormItem,
	FormLabel,
	FormMessage,
} from "../../components/form";

type StandardFormItemProps = PropsWithChildren & {
	label: string;
	description?: string;
	gridColSpan: number;
};

const StandardFormItem = ({
	label,
	description,
	gridColSpan,
	children,
}: StandardFormItemProps) => {
	return (
		<FormItem className={`col-span-${gridColSpan} flex flex-col gap-3`}>
			<FormLabel className="items-start flex flex-col gap-1 text-sm font-medium">
				{label}
				{description && (
					<p className="text-sm font-normal text-muted-foreground">
						{description}
					</p>
				)}
			</FormLabel>
			<FormControl>{children}</FormControl>
			<FormMessage />
		</FormItem>
	);
};

export { StandardFormItem };
